import 'Components/AppComponents/BouncingArrow/BouncingArrow.css';

export default function BouncingArrow(props: any) {
    return <div className={`arrow flex items-center duration-1000 ${props.appear? ' appear bounce-arrow ':''} ` + (props.className? props.className : '')} style={{backgroundImage: `url(/images/arrow.png)`}}>
        {/* <div className="ml-12 text-2xl font-bold">Click Here</div>         */}
    </div>
}